import { Cog6ToothIcon, RectangleStackIcon } from '@heroicons/vue/20/solid';

const websiteSidebarConfig = [
  {
    title: 'Realtime Analytics',
    icon: RectangleStackIcon,
    path: '/realtime/',
    website: true,
  },
  {
    section: true,
  },
  {
    title: 'Settings',
    icon: Cog6ToothIcon,
    path: '/settings/',
    website: true,
  },
];

export { websiteSidebarConfig };
